import { verifieraPinkod, bekraftaStaKvar, aktuellMiljo } from "./StaKvarApi";
import { AxiosError, AxiosResponse } from "axios";
import { useStore } from "@/store";
import i18n from "../i18n";

export interface VerifieraKodPayload {
	organisationsnummer: string,
	pinkod: string,
};

export interface BekraftaStaKvarPayload {
	organisationsnummer: string,
	pinkod: string,
	staKvar: boolean,
	epost: string | null,
};

export const kontrolleraKod = (tillNastaSida: () => void): void => {
	const store = useStore();
	store.aterstall();
	const payload = {
		organisationsnummer: store.state.orgnummer,
		pinkod: store.state.kod,
	} as VerifieraKodPayload;
	
	skickaApiRequest<VerifieraKodPayload>(payload, verifieraPinkod, (response: AxiosResponse) => {
		if (response.status != 200) {
			store.state.felmeddelande = `Oväntat fel..`;
			return;
		}
		store.state.vantarPaResponse = false;

//		console.log(`verifieraPinkod response från backend <-- ${JSON.stringify(response.data, null)}`);

		if (response.data.pinkodOk) {
			store.state.verifierad = true;
			store.state.foretagsnamn = response.data.foretagsinformation.namn;
			store.state.arForetag = response.data.foretagsinformation.arForetag;
			store.state.orgnummerKomplett = response.data.foretagsinformation.organisationsnummer;
			tillNastaSida();
		} else {
			store.state.felmeddelande = response.data.meddelande;
		}
	});
}

export const verifieraOchBekrafta = (tillNastaSida: () => void) => {
	const store = useStore();
	store.state.felmeddelande = "";

	const payload = {
		organisationsnummer: store.state.orgnummer,
		pinkod: store.state.kod,
		staKvar: store.state.staKvar,
		epost: store.state.epost,
	} as BekraftaStaKvarPayload;

	skickaApiRequest<BekraftaStaKvarPayload>(payload, bekraftaStaKvar, (response: AxiosResponse) => {
		if (response.status != 200) {
			store.state.felmeddelande = `Oväntat fel..`;
			return;
		}
		store.state.vantarPaResponse = false;

//		console.log(`bekraftaStaKvar response från backend <-- ${JSON.stringify(response.data, null)}`);

		if (response.data.pinkodOk) {
			store.state.kvittensnummer = response.data.kvittensnummer;
			store.state.ankomsttid = response.data.ankomsttid;
			tillNastaSida();
		} else {
			store.state.felmeddelande = response.data.meddelande;
		}
	});
}

export const skickaApiRequest = <Payload>(payload: Payload, asyncRequestAnrop:(payload: Payload) => Promise<AxiosResponse>, responseCallback:(response: AxiosResponse) => void) => {
	const store = useStore();
	store.state.vantarPaResponse = true;
	const timestamp: string = new Date().toLocaleString("sv-SE").replace("T", " ").split(".")[0];
	asyncRequestAnrop(payload)
	.then(responseCallback)
	.catch((error: AxiosError) => {
		store.state.felmeddelande = i18n.global.t("general.errors.technical_error_try_again", { number: store.state.orgnummer, timestamp: timestamp });
		store.state.vantarPaResponse = false;
	})
}

export const hamtaMiljo = async () : Promise<string> => {
	try {
		const response = await aktuellMiljo();
		const data = await response.data;
		return data;
	  } catch (error: any) {
		throw error.message;
	  }
}

